import script from "./CargarPDFs.vue?vue&type=script&setup=true&lang=js"
export * from "./CargarPDFs.vue?vue&type=script&setup=true&lang=js"

import "./CargarPDFs.vue?vue&type=style&index=0&id=34624b60&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34624b60"]])

export default __exports__